import React from 'react'
import "./coverbanner.css"
import { connect } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";

function Coverbanner({ rootData }) {
    return (
        <div className="mobileBanner h-40 w-full block lg:hidden">
            {rootData.bannerImage ? <img src={rootData.bannerImage} alt="" className=" h-full w-full object-cover" /> : <Skeleton
                variant="rect"
                className="mb-4"
                height={100}
            />}
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps, null)(Coverbanner)
